<template>
  <FactureCard>
    <template v-slot:title>
      Prélèvements
    </template>
    <v-container style="max-width:300px;">
      <v-stepper v-model="stepper" vertical>
        <template v-for="(item, index) in listeEcheanciers">
          <v-stepper-step :key="'step' + index + 1"
                          :step="index + 1"
                          :complete="item.resteDu === 0">
            {{ formatDateEcheance(item.dateEcheance) }} - {{ formatPrix(item.resteDu) }}
          </v-stepper-step>
          <v-stepper-content :step="index + 1" :key="'content' + index + 1"></v-stepper-content>
        </template>
      </v-stepper>
    </v-container>
  </FactureCard>
</template>

<script>
  import FactureCard from "./FactureCard"

  export default {
    components: { FactureCard },
    props: ['listeEcheanciers', "formatPrix"],
    data() {
      return {
        stepper: 1
      }
    },
    mounted() {
      let lastIndex = 1
			this.listeEcheanciers.forEach((appel, index) => {
        if (appel.resteDu === 0) {
          lastIndex = index + 2
        }
      })
      this.stepper = lastIndex
    },
    methods: {
      // Si la date d'écheance est null on affiche la date d'aujourd'hui.
      formatDateEcheance(dateEcheance)
      {
        if(dateEcheance == null) 
        {
          return this.getTodayDateFormatted();
        }
        return dateEcheance;
      },
      getTodayDateFormatted()
      {
        return new Date().toLocaleDateString("fr-CA");
      }
    },
  }
</script>